import { WORD_COUNT_RANGES } from '../constants';

export default function getDurationBasedOnWordCount(wordsCount) {
  const range = WORD_COUNT_RANGES.find((it) => wordsCount <= it.minWords);

  if (!range) {
    return '';
  }

  return range.duration;
}